import { ArrowUpRight, ListTodoIcon } from "lucide-react";

export const TasksTrigger = ({
  onClick,
  label,
}: {
  onClick: () => void;
  label?: string;
}) => (
  <button
    onClick={onClick}
    className="border group border-transparent hover:bg-secondary hover:shadow-xs rounded-md group flex-1 flex items-center gap-2"
  >
    <div className="size-9 rounded-md bg-secondary group-hover:bg-background border border-border flex items-center justify-center">
      <ListTodoIcon className="size-4" />
    </div>
    <span className="text-sm font-semibold">{label ?? "To-dos"}</span>
    <div className="size-9 rounded-md transition-opacity duration-150 opacity-0 group-hover:opacity-100 ml-auto bg-transparent flex items-center justify-center">
      <ArrowUpRight className="size-4" />
    </div>
  </button>
);
